import * as React from 'react';
import { IHttpApi } from '@cian/http-api';
import { ILogger } from '@cian/logger/shared';
import { NewbuildingMVKWidget } from '@cian/mvk-widget';
import { mergeStyles } from '@cian/utils';
import '@cian/mvk-widget/dist/mvk-fotorama.css';
import * as styles from './newbuilding_mvk.css';
import { IGetNewbuildingPolygonsResponse } from '../../repositories/newbuilding-mvk/v2/get-newbuilding-polygons';

export interface INewbuildingMVKStoreProps {
  MVKData?: IGetNewbuildingPolygonsResponse;
  isOpen: boolean;
  offerId: number;
  sectionId?: number;
}

export interface INewbuildingMVKOwnProps {
  httpApi: IHttpApi;
  logger?: ILogger;
}

export interface INewbuildingMVKDisspatchProps {
  closeWidget(): void;
}

export interface INewbuildingMVKState {
  MvkWidget?: typeof NewbuildingMVKWidget;
}

const MIN_WIDGET_HEIGHT = 480;

type NewbuildingMVKProps = INewbuildingMVKStoreProps & INewbuildingMVKOwnProps & INewbuildingMVKDisspatchProps;

export class NewbuildingMVK extends React.Component<NewbuildingMVKProps, INewbuildingMVKState> {
  private container: HTMLDivElement | null;

  public async componentDidMount() {
    try {
      const { NewbuildingMVKWidget } = await import('@cian/mvk-widget');
      this.setState({ MvkWidget: NewbuildingMVKWidget });
    } catch (e) {}
  }

  public UNSAFE_componentWillReceiveProps(nextProps: NewbuildingMVKProps) {
    if (nextProps.isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  }

  public render() {
    const { httpApi, logger, MVKData, offerId, isOpen, closeWidget, sectionId } = this.props;

    if (!MVKData) {
      return null;
    }

    const { MvkWidget } = this.state;

    return (
      <div
        ref={ref => (this.container = ref)}
        onClick={this.handleClose}
        {...mergeStyles(styles['container'], !isOpen && styles['hidden'])}
      >
        {isOpen && MvkWidget && (
          <MvkWidget
            // Надо убирать api-models из mvk-widget CD-49347
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            MVKData={MVKData as any}
            httpApi={httpApi}
            logger={logger}
            sectionId={sectionId}
            offerId={sectionId ? undefined : offerId}
            usePlace="offer-card"
            onClose={closeWidget}
            containerStyles={{ height: this.getWidgetHeight() }}
          />
        )}
      </div>
    );
  }

  private handleClose: React.MouseEventHandler<HTMLDivElement> = event => {
    if (event.target === this.container) {
      this.props.closeWidget();
    }
  };

  private getWidgetHeight = () => {
    return this.container ? this.container.offsetHeight - 100 : MIN_WIDGET_HEIGHT;
  };
}
